import { gaEvent } from '~/plugins/gtagGA4.js'

export default {
  watch: {
    portal: {
      handler (value) {
        this.updatePortal(value)
      },
      deep: true
    }
  },
  methods: {
    portalComponents () {
      const portal = this.portal
      const portalElement = document.querySelector('portal')

      const updatePortal = this.updatePortal

      if (!AFRAME.components.portal) {
        AFRAME.registerComponent('portal', {
          schema: {
            // todo make this condition for circle entranc
            // width: { default: 10 },
            // height: { default: 10 }
            width: { default: 10 },
            height: { default: 35 }
          },
          init () {
            this.camera = document.getElementById('camera')
            this.contents = document.getElementById('portal-contents')
            this.walls = document.getElementById('hider-walls')
            this.portalWall = document.getElementById('portal-wall')

            this.isInPortalSpace = false
            this.wasOutside = true

            // this.portalHiderRing = document.querySelector('#portalHiderRing')

            updatePortal(portal)

            // // GLBs
            // this.portalPolygon = document.getElementById('portalPolygon')
            // this.portalLight = document.getElementById('portalLight')
            // this.portalLight.setAttribute(
            //   'gltf-model',
            //   'temp/pp_emmissive_orb.glb'
            // )

            // // temp
            this.portalRim = document.getElementById('portalRim')
            // this.portalRim.setAttribute(
            //   'gltf-model',
            //   'temp/final_portal_01_sm.glb'
            // )

            // img
            this.portalShadow = document.getElementById('portalShadow')
            this.portalShadow.setAttribute('src', '/temp/blob-shadow.png') // temp

            // todo wait until scene is visible
            // this.portalHiderRing.setAttribute('animation__1', {
            //   property: 'radius-inner',
            //   dur: 1500,
            //   from: '0.001',
            //   to: '3.5',
            //   easing: 'easeOutElastic'
            // })

            this.portalRim.setAttribute('animation__2', {
              property: 'scale',
              dur: 1500,
              from: '0.001 0.001 0.001',
              to: '4.3 4.3 4.3',
              easing: 'easeOutElastic'
            })

            // portalVideo.setAttribute('animation__3', {
            //   property: 'scale',
            //   dur: 1500,
            //   from: '0.001 0.001 0.001',
            //   to: '7 7 1',
            //   easing: 'easeOutElastic'
            // })

            this.portalShadow.setAttribute('animation__4', {
              property: 'scale',
              dur: 1500,
              from: '0.001 0.001 0.001',
              to: '15.5 2 11',
              easing: 'easeOutElastic'
            })
          },
          tick () {
            if (this.camera) {
              const { position } = this.camera.object3D
              // //console.log('camera position', position)
              const isOutside = position.z > 0
              const withinPortalBounds =
                position.y < this.data.height &&
                Math.abs(position.x) < this.data.width / 2
              if (this.wasOutside !== isOutside && withinPortalBounds) {
                this.isInPortalSpace = !isOutside
              }
              this.contents.object3D.visible = this.isInPortalSpace || isOutside
              this.walls.object3D.visible = !this.isInPortalSpace && isOutside
              this.portalWall.object3D.visible =
                this.isInPortalSpace && !isOutside
              // this.portalVideo.object3D.visible = isOutside
              this.wasOutside = isOutside
            }
          }
        })
      }
    },
    updatePortal (portal) {
      // const portalElement = document.querySelector('portal')
      debugger
      if (portal) {
        const portalElement = document.querySelector('[portal]')
        portalElement.setAttribute('visible', portal.visible)

        if (portal.visible && portal.skyboxImg && portal.skyboxImg.file) {
          const portalArt = document.getElementById('skybox-img')
          portalArt.setAttribute('src', portal.skyboxImg.file)
        }

        this.updateGround(portal.ground)

        if (portal.polygon) { this.updatePortalPolygon(portal.polygon) }
        if (portal.rim) { this.updateRim(portal.rim) }
        if (portal.light) { this.updateLight(portal.light) }
        if (portal.reward) { this.updatePortalReward(portal.reward, portal.rewardUrl, portal.position) }

        // document.querySelector('[sky]').setAttribute('src', portal.image)

        // const loader = new THREE.TextureLoader()
        // const texture = new THREE.TextureLoader().load(portal.image)
        // // immediately use the texture for material creation
        // const material = new THREE.MeshBasicMaterial({ map: texture })
        // document.querySelector('[sky]').getObject3D('mesh').material = material
      }
    },
    updatePortalPolygon (polygon) {
      const setDefaultModel = this.setDefaultModel
      this.portalPolygon = document.getElementById('portalPolygon')

      this.portalPolygon.addEventListener('model-error', function (evt) {
        // console.log('The wrapper entity didnt load: ' + evt.type)
        setDefaultModel()
      })

      if (polygon && polygon.formats && polygon.formats.length) {
        polygon.formats.forEach(async (format) => {
          if (
            format.formatType === 'GLB' ||
            format.formatType === 'GLTF' ||
            format.formatType === 'GLTF2'
          ) {
            if (
              this.portalPolygon &&
              format.root.contentType === 'model/gltf+json'
            ) {
              await this.portalPolygon.setAttribute(
                'gltf-model',
                format.root.url
              )
            }
          }
        })
      } else {
        setDefaultModel()
      }
      if (polygon && polygon.scale) {
        const scale = polygon.scale
        this.portalPolygon.setAttribute('scale', `${scale} ${scale} ${scale}`)
      }
    },
    updateRim (rim) {
      this.portalRim = document.getElementById('portalRim')
      if (rim && rim.formats && rim.formats.length) {
        rim.formats.forEach(async (format) => {
          if (
            format.formatType === 'GLB' ||
            format.formatType === 'GLTF' ||
            format.formatType === 'GLTF2'
          ) {
            if (
              this.portalRim &&
              format.root.contentType === 'model/gltf+json'
            ) {
              await this.portalRim.setAttribute('gltf-model', format.root.url)
            }
          }
        })
      }
    },
    updateLight (light) {
      this.portalLight = document.getElementById('portalLight')
      if (light && light.formats && light.formats.length) {
        light.formats.forEach(async (format) => {
          if (
            format.formatType === 'GLB' ||
            format.formatType === 'GLTF' ||
            format.formatType === 'GLTF2'
          ) {
            if (
              this.portalLight &&
              format.root.contentType === 'model/gltf+json'
            ) {
              await this.portalLight.setAttribute('gltf-model', format.root.url)
            }
          }
        })
      }
    },
    updateGround (ground) {
      const portalGround = document.getElementById('portalGround')

      const onModelProgress = function (evt) {
        console.log(evt.target.progress, evt.progress)
      }

      const onModelLoaded = function (evt) {
        console.log('model-loaded fired for portalGround')
        const loadingComponent = document.querySelector('[loading]')
        if (loadingComponent) {
          const portalScene = document.querySelector('[portal]')
          if (portalScene && loadingComponent.parentNode === portalScene) {
            portalScene.removeChild(loadingComponent)
          } else {
            // If the loading component exists but isn't a direct child of portalScene,
            // remove it from its current parent
            loadingComponent.parentNode?.removeChild(loadingComponent)
          }
        }

        gaEvent({ event: 'portal_ground_loaded', params: {} })
        const gltf = evt.detail.model // This is the THREE.js GLTF scene
        console.log('Portal Scene ground Loaded:', gltf)

        // Store the scene object reference instead of trying to store the whole GLTF
        window.loadedGLTFScene = gltf

        portalGround.removeEventListener('model-loaded', onModelLoaded)
        portalGround.removeEventListener('model-error', onModelError)

        // make visible
        portalGround.setAttribute('visible', true)
      }

      const onModelError = function (evt) {
        console.log('model-error fired for portalGround')
        portalGround.removeEventListener('model-loaded', onModelLoaded)
        portalGround.removeEventListener('model-error', onModelError)
      }

      // portalGround.keys(window).forEach((key) => {
      //   console.log('key ' + key)
      // })

      debugger
      portalGround.addEventListener('model-onProgress', onModelProgress)
      portalGround.addEventListener('model-loaded', onModelLoaded)
      portalGround.addEventListener('model-error', onModelError)

      if (ground) {
        if (ground.formats && ground.formats.length) {
          ground.formats.forEach(async (format) => {
            if (
              format.formatType === 'GLB' ||
              format.formatType === 'GLTF' ||
              format.formatType === 'GLTF2'
            ) {
              if (
                portalGround &&
                format.root.contentType === 'model/gltf+json'
              ) {
                await portalGround.setAttribute(
                  'gltf-model',
                  format.root.url
                )
              }
            }
          })
        }
      } else {
        portalGround.setAttribute('visible', false)
      }
    },
    updatePortalReward (polygon, link, position) {
      const portalReward = document.getElementById('portalReward')
      portalReward.setAttribute('visible', true)

      if (link) {
        portalReward.addEventListener('click', (e) => {
          this.$nuxt.$emit('actionClick', { link })
        })
      }
      if (position) {
        portalReward.setAttribute('position', position)
      }
      portalReward.addEventListener('model-error', function (evt) {
        console.log('The reward poly entity didnt load: ' + evt.type)
        // setDefaultModel()
      })
      portalReward.addEventListener('model-loaded', function (evt) {
        console.log('The reward poly entity loaded: ' + evt.type)
      })
      if (polygon && polygon.formats && polygon.formats.length) {
        polygon.formats.forEach(async (format) => {
          if (
            format.formatType === 'GLB' ||
            format.formatType === 'GLTF' ||
            format.formatType === 'GLTF2'
          ) {
            if (
              portalReward &&
              format.root.contentType === 'model/gltf+json'
            ) {
              await portalReward.setAttribute(
                'gltf-model',
                format.root.url
              )
            }
          }
        })
      }
    },
    setDefaultModel () {
      this.portalPolygon = document.getElementById('portalPolygon')
      if (this.portalPolygon) { this.portalPolygon.setAttribute('gltf-model', '/gltf/audiodrop1.glb') }
    },

    showLoadingModel () {
      const loadingComponent = document.querySelector('[loading]')
      if (loadingComponent) {
        loadingComponent.setAttribute('gltf-model', '/gltf/drops_loading.glb')
        loadingComponent.setAttribute('position', '0 9 0')

        loadingComponent.setAttribute(
          'animation',
          'property: rotation; to: 0 0 360; loop: true; dur: 3000; easing: linear;'
        )
      }
    }

  }
}
